import React from 'react';
import './Sections.scss';

function Section4() {
  return (
    <section className="sections sections-section4">
      <p className="sections-copy">
        “One important factor in this massive wealth difference between homeowners and renters is
        that the rent you pay disappears each month, whereas at least a portion of the mortgage
        payment goes toward reducing the principal and thus constitutes a kind of forced savings,”
        says Yun. “It’s hard to time the market, but historical data shows that people who are
        homeowners do build wealth over time.”
      </p>
      <p className="sections-copy">
        Indeed, Yun points out that homeowners in the U.S. can refinance mortgage loans, which means
        that they do not need to worry too much about whether they are getting a loan at the lowest
        possible rate or whether interest rates could fall further.
      </p>
      <div className="quote">
        <div className="quote__contents">
          <div className="quotationMark">“</div>
          <blockquote className="quote__copy">
            It’s hard to time the market, but historical data shows that people who are homeowners
            do build wealth over time.”
          </blockquote>
          <div className="quote__caption">
            Dr. Lawrence Yun,{' '}
            <span className="italic">Chief Economist at the National Association of Realtors</span>
          </div>
        </div>
      </div>
      <p className="sections-copy">
        “Some people who are looking to buy a home now may see 30-year mortgage rates sliding toward
        6% and wonder whether they should wait until interest rates fall even further,” notes Yun.
        “But we might not see significantly lower rates over the next three to four years. Buyers
        who wait could miss out on a chance to build equity while they wait for rates to fall. As
        long as buyers are not overstretching their finances or pursuing risky mortgages, they can
        take out a mortgage loan at 6% and then refinance later to lower their monthly payments if
        mortgage rates do drop to 4% several years from now.”
      </p>
    </section>
  );
}

export default Section4;
